import React, { useEffect, useState } from "react";
import "./header.css";

const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setSticky(window.scrollY > 40);
    });
  }, []);
  return (
    <div>
      <header className={sticky ? "premium-header sticky" : "premium-header"}>
        <div className="">
          <div className="header-wrapper">
            {/* Logo */}

            <a href="/" className="logo">
              <img src="./images/logo.png" alt="Logo" />
            </a>

            {/* Desktop Menu */}

            <nav className="desktop-nav">
              <a href="/giftcity">Why GIFT City</a>

              <a href="/">Office Spaces</a>

              <a href="/">Business Setup</a>

              <a href="/">Residential</a>

              <a href="/aboutus">About Us</a>

              <a href="/contactus">Contact</a>
            </nav>

            {/* Button */}

            {/* <div className="header-btn">
              <button>
                Begin GCC Setup
                <i className="bi bi-arrow-right"></i>
              </button>
            </div> */}

            {/* Mobile Toggle */}

            <div
              className={mobileMenu ? "menu-toggle active" : "menu-toggle"}
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}

      <div className={mobileMenu ? "mobile-menu active" : "mobile-menu"}>
        <a href="/giftcity">Why GIFT City</a>

        <a href="/">Office Spaces</a>

        <a href="/">Business Setup</a>

        <a href="/">Residential</a>

        <a href="/aboutus">About Us</a>

        <a href="/contactus">Contact</a>
        <button>Begin GCC Setup</button>
      </div>
    </div>
  );
};

export default Header;
